// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__UubkJ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  width: calc(100% - 20px);
}

.styles_container__UubkJ > div {
  width: 100%;
}

.styles_container__UubkJ > div > div {
  width: 100%;
}

.styles_container__UubkJ p {
  padding: 0 5px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
}

.styles_inputContainerModal__TOwF8 {
  min-width: 60vw;
  padding: 10px;
  box-sizing: border-box;
  min-height: 15vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 433px;
}

.styles_inputContainerModal__TOwF8 > p {
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ChannelPageCardMobile/styles.module.scss"],"names":[],"mappings":"AAAA;EAIE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAEA,wBAAA;AAHF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;AAJF;;AAOA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;AAJF;;AAWA;EACE,aAAA;AARF","sourcesContent":[".container {\n  // width: 236px;\n  // min-height: 349px;\n  // width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 10px;\n  // margin-top: 40px;\n  width: calc(100% - 20px);\n\n}\n\n.container>div {\n  width: 100%;\n}\n\n.container>div>div {\n  width: 100%;\n}\n\n.container p {\n  padding: 0 5px;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n}\n\n.inputContainerModal {\n  min-width: 60vw;\n  padding: 10px;\n  box-sizing: border-box;\n  min-height: 15vw;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  min-height: 433px;\n  //   justify-content: space-around;\n  //   align-items: flex-start;\n  //   // min-height:400px;\n  // min-height:233px;\n}\n\n.inputContainerModal>p {\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__UubkJ`,
	"inputContainerModal": `styles_inputContainerModal__TOwF8`
};
export default ___CSS_LOADER_EXPORT___;
